import { render, staticRenderFns } from "./selectPolicy.vue?vue&type=template&id=6584ede0&scoped=true"
import script from "./selectPolicy.vue?vue&type=script&lang=js"
export * from "./selectPolicy.vue?vue&type=script&lang=js"
import style0 from "./selectPolicy.vue?vue&type=style&index=0&id=6584ede0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584ede0",
  null
  
)

export default component.exports